<template>
	<v-container>
        <v-row dense>
          <!-- Left Column -->
          <v-col cols="6">
			<TimerSetting v-if="is_load" :config="config" @displayEmbedCode="displayEmbedCode" />
			
            <!-- Content for the left column goes here -->
          </v-col>

          <!-- Right Column -->
          <v-col cols="6">
			<Timer v-if="is_load" :config="config" />
            <!-- Content for the right column goes here -->
          </v-col>
        </v-row>

		<CodeCopyDialog 
			:setting="code_copy_setting"
		>

		</CodeCopyDialog>

	</v-container>
</template>

<script>
	// import 子組件
	import CodeCopyDialog from "@/components/Utils/CodeCopyDialog.vue";

	// DatePicker!
	// import DatePicker from 'vue2-datepicker'
	import 'vue2-datepicker/index.css'
	import 'vue2-datepicker/locale/zh-tw';

	import Timer from './Timer.vue'
	import TimerSetting from './TimerSetting.vue'

	// api
	import {
		apiGetSettingById	
	} from '@/api/iframe.js'

	export default {
		name: 'TimerEditor',
		components: {
			Timer,
			TimerSetting,
			CodeCopyDialog
			// DatePicker,
			// CodeDialog
		}, 		
		data: function() {
			return {
				config: {

					// 設定檔名稱
					name: "",

					// 開始時間
					start_at: new Date(new Date().setDate(new Date().getDate() - 1)),

					// 結束時間
					end_at: new Date(new Date().setDate(new Date().getDate() + 2)),

					// 活動開始時間
					campaign_start_at: new Date(),

					// 活動結束時間
					campaign_end_at: new Date(new Date().setDate(new Date().getDate() + 1)),

					// iframe height
					iframe_height: 200,

					selected_setting: {
						tab_name: "活動開始前",
						type: "warm_up",
						background_1:{
							color: "",
							menu: false
						},
						background_2:{
							color: "",
							menu: false
						},
					},
					selected_setting_tab_name: '活動開始前',

					settings: [
						{
							tab_name: "活動開始前",
							type: "warm_up",
							background_1:{
								color: "#A8ADBB",
								menu: false
							},
							background_2:{
								color: "#856667",
								menu: false
							},
							campaign_text: {
								text: "活動開始前",
								size: '20',
								color: '#FFFFFF',
								menu: false
							},
							start_at: null,
							end_at: null
						},
						{
							tab_name: "活動進行中",
							type: "campaign",
							background_1:{
								color: "#A90F1D",
								menu: false
							},
							background_2:{
								color: "#A90F1D",
								menu: false
							},
							campaign_text: {
								text: "活動進行中",
								size: '20',
								color: '#FFFFFF',
								menu: false
							},
							start_at: null,
							end_at: null
						},
						{
							tab_name: "活動結束後",
							type: "over",
							background_1:{
								color: "#334163",
								menu: false
							},
							background_2:{
								color: "#724448",
								menu: false
							},
							campaign_text: {
								text: "活動結束後",
								size: '20',
								color: '#FFFFFF',
								menu: false
							},
							start_at: null,
							end_at: null
						},
					],

					advanced_config: {
						repeat_day: 0,
					},
					preview_at: null,

					add_column: {
						timer_style: {

							time_size: 36,

							time_1: {
								color: "#F1F3A5",
								menu: false
							},
							time_2: {
								color: "#FFCB70",
								menu: false
							},
							unit: {
								size: 16,
								color: '#FFFFFF',
								menu: false,
							},
							symbol: {
								size: 26,
								color: '#FFFFFF',
								top: 3,
								letter_spacing: 8,
								menu: false,
							}
						},
						repeat_day: 0,
					},

					error_message: {
						name:'',
						start_at: '',
						end_at: '',
						campaign_start_at: '',
						campaign_end_at: '',
						preview: '',
					}
				},

				is_load: false,

				// 2023 Pantone 十大代表色
				color_template_items: {
					'不需要模板': {
						'bg_color' : '#A90F1D',
						'bg_color_2' : '#A90F1D',
						'number_color': '#F1F3A5',
						'number_color_2': '#FFCB70'
					},
					'萬歲洋紅': {
						'bg_color': '#BB2649',
						'bg_color_2': '#BB2649',
						'number_color': '#F1695D',
						'number_color_2': '#FD9B7F'
					},
					'夏日戀曲': {
						'bg_color': '#879AA7',
						'bg_color_2': '#7AA3C0',
						'number_color': '#94EDFA',
						'number_color_2': '#BCCECB'
					},
					'甜菜根紫': {
						'bg_color': '#CF2D71',
						'bg_color_2': '#CF2D71',
						'number_color': '#FF716D',
						'number_color_2': '#FFE4B6'
					},
					'帝國黃': {
						'bg_color': '#F7D000',
						'bg_color_2': '#F7D000',
						'number_color': '#D8A5F3',
						'number_color_2': '#AA2BFF'
					},
					'橘柚色': {
						'bg_color': '#F07427',
						'bg_color_2': '#F07427',
						'number_color': '#F1F3A5',
						'number_color_2': '#FFCB70'
					},
					'天使藍': {
						'bg_color': '#83C5CD',
						'bg_color_2': '#83C5CD',
						'number_color': '#58C2FF',
						'number_color_2': '#6599F1'
					},
					'水晶玫瑰': {
						'bg_color': '#F8C5C8',
						'bg_color_2': '#F8C5C8',
						'number_color': '#FCFF96',
						'number_color_2': '#E6E4E0'
					},
					'薰衣草': {
						'bg_color': '#E6E6FA',
						'bg_color_2': '#E6E6FA',
						'number_color': '#ABD4FA',
						'number_color_2': '#99A9D6'
					},
					'香草奶油': {
						'bg_color': '#F5D8C6',
						'bg_color_2': '#FADFCE',
						'number_color': '#E9BFBA',
						'number_color_2': '#C2AB92'
					},
					'灰丁香': {
						'bg_color': '#D4CACD',
						'bg_color_2': '#E0CFCA',
						'number_color': '#FFC4F3',
						'number_color_2': '#F1F1F1'
					}
				},
				code_copy_setting: {
					html_code : '',
					is_show: false,
					title: '在頁面嵌入倒數計時器',
					subtitle: '請將這段程式碼放在網頁想要顯示的區塊中 :',
					description: '',
					width: '600'
				}
			}
		},
		created: async function(){
			// 先判斷是新還是舊 
			// 如果是舊就讀設定檔

			// 讀舊檔
			if (this.$route.params.iframe_id) {
				let config = await this.loadData(this.$route.params.iframe_id)
				if (config === null) {
					this.$root.vtoast.show({ message: "找不到設定檔" }) 
					this.$router.push('/' + this.selectedContainer.container_id + '/optimize_site/iframe_timer/')
				}
				this.config.name = config.name
				this.config.start_at = new Date(config.start_at.replace(' ', 'T'))
				this.config.end_at = new Date(config.end_at.replace(' ', 'T'))
				this.config.campaign_start_at = new Date(config.campaign_start_at.replace(' ', 'T'))
				this.config.campaign_end_at = new Date(config.campaign_end_at.replace(' ', 'T'))
				this.config.iframe_height = config.iframe_height
				this.config.settings = JSON.parse(config.settings)
				this.config.add_column = JSON.parse(config.add_column)
				if (!this.config.add_column['repeat_day']) {
					this.config.add_column['repeat_day'] = 0
				}

				// 強迫顯示要取代的麵包屑
				this.$store.commit('update_breadcrumbs',[
					{
						"text": "頁面優化",
						disabled: true,
					},
					{
						"text": "倒數計時器",
						disabled: false,
						href: `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/iframe_timer/`
					},
					{
						"text": this.config.name,
					}
				])
			}
			// 新的什麼都不用做
			this.is_load = true

		},
		methods: {
			loadData: async function(id) {
				let data = null
				let that = this
				data = await apiGetSettingById(
					id, this.$route.params.org_id
				).then(function(resp){
					return resp.data.data
				}).catch(function(error){
					that.$root.vtoast.show({ message: "取得舊檔失敗，原因: " + (error.response ? error.response : error) }) 
					return null
				})

				return data
			},
			displayEmbedCode: function(){
				this.code_copy_setting.is_show = true
				this.code_copy_setting.html_code = `<iframe src="${process.env.VUE_APP_DOMAIN}/embed/timer?id=${this.$route.params.iframe_id}" style="border:0px; width: 100%; height:${this.config.iframe_height}px"></iframe>`
			},
		},		
		computed: {
		},
	}
</script>
<style scoped>
.container {
	display: flex;
	flex-direction: row;
	height: 100%;
	max-width: 100% !important;
}
.preview-container {
	width: 50%;
	height: 100%;
	display: flex;
	align-items: center;
}	
.preview-container > iframe {
	width: 100%;
	height: 50%;
}
.setting-container {
	padding: 0px 20px;
	width:50%;
	overflow: scroll;
}
.setting-container > article {
	background-color: #FFF;
	padding: 10px 20px;
}
.setting-container > article > h2 {
	margin-bottom: 10px;
}
.input-wrapper {
	display: flex;
	flex-direction: row;
}
.field-cotainer-column {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-bottom: 10px;
}
.input-wrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 5px;
}
.input-wrapper > h4 {
	font-weight: bold;
	margin-right: 5px;
}
.input-wrapper input[type="text"], .input-wrapper input[type="number"]  {
	padding: 10px 18px 10px 18px;
	border-radius: .4285rem;
	border-color: #2b3553;
	border: 1px solid #cad1d7;
	width: 100%;
	outline: none;
	transition: all .3s;
}
.input-wrapper .mx-datepicker {
	width: 98%;
}
.footer {
	display: flex;
	justify-content: flex-end;
}
</style>